import { render, staticRenderFns } from "./IntegraGrupoPorto.vue?vue&type=template&id=2a5bba78"
import script from "./IntegraGrupoPorto.vue?vue&type=script&lang=js"
export * from "./IntegraGrupoPorto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports